export default values => {
    const errors = {};
    const requiredFields = ["lseId", "firstName", "lastName", "email"];
    requiredFields.forEach(field => {
        if (!values[field]) {
            errors[field] = "Required";
        }
    });

    if (values.email) {
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailRegex.test(values.email)) {
            errors.email = "Invalid email address";
        } else if (!values.email.toLowerCase().endsWith("@lse.ac.uk")) {
            errors.email = "Email must end with @lse.ac.uk";
        }
    }

    return errors;
};
